/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/InvoiceLink.js
 */

import React from 'react';
import config from '../config';
import { getBaseUrlFromConfig } from '../utils/url_helpers';

const zuoraBaseURL = getBaseUrlFromConfig(config.zuora);

const getLink = (data) =>
  `${zuoraBaseURL}/apps/NewInvoice.do?method=view&invoice_number=${data.id}`;

const InvoiceLink = ({ data, type }) => {
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <a href={getLink(data)}>
          <div className="Type">Invoice</div>
          <div className="Value">{data.id}</div>
        </a>
      </div>
      <div className="SummaryLink">
        <a href={getLink(data)}>{getLink(data)}</a>
      </div>
      <div className="SummaryData">
        <p>Date : {new Date(data.date).toLocaleDateString()}</p>
        <p>
          Customer:{' '}
          {data.customer && data.customer.name
            ? data.customer.name
            : 'No customer associated with this invoice'}
        </p>
      </div>
    </div>
  );
};

export default InvoiceLink;
